'use client'

import type { EmbeddedVideoProps } from '@pearlconvert/ui/components/embedded-video/embedded-video.types'

import { theme } from '@maestro/local/theme'
import { useEmbeddedVideo } from '@pearlconvert/ui/components/embedded-video/batons/use-embedded-video-baton'

import '@pearlconvert/ui/components/embedded-video/styles/embedded-video.scss'

export default function EmbeddedVideo({
  url,
  autoplay = false,
  ConsentGate,
}: EmbeddedVideoProps) {
  const { embedUrl, isValidVideo } = useEmbeddedVideo({ url, autoplay })
  const { consents } = theme().site.consentConfig

  if (!isValidVideo || !embedUrl) {
    return null
  }

  return (
    <ConsentGate contentType="video">
      <iframe
        data-cookieconsent={consents}
        data-cookieblock-src={embedUrl}
        className="embedded-video"
        src={embedUrl}
        title="Embedded video player"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </ConsentGate>
  )
}
